import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { first } from 'rxjs/operators';
import { RestorePasswordModel } from '../../../model/restorepasswordmodel';
import { RestorePasswordService } from '../../../service/restore-password.service';

@Component({
  selector: 'app-new-password-phase',
  templateUrl: './new-password-phase.component.html',
  styleUrls: ['./new-password-phase.component.css']
})
export class NewPasswordPhaseComponent implements OnInit {

    isPwdMissing = false;
    isPwdCheckMissing = false;
    isCheckFail = false;
    newPassword: string;
    newPasswordCheck: string;
    @Input() restorePwdModel: RestorePasswordModel;
    // tslint:disable-next-line:no-output-on-prefix
    @Output() onSuccess = new EventEmitter<RestorePasswordModel>();

    constructor(private restorePwdSrv: RestorePasswordService) { }

    ngOnInit() {
    }

    next() {
        if (!this.validateRequest()) {
            return;
        }

        this.restorePwdModel.newPassword = this.newPassword;
        this.restorePwdModel.newPasswordCheck = this.newPasswordCheck;
        this.restorePwdSrv.pwd(this.restorePwdModel)
            .pipe(first())
            .subscribe(
                data => {
                    if (data.outcome === 'OK') {
                        this.onSuccess.emit(this.restorePwdModel);
                    }
                },
                error => {
                    return;
                }
            );
    }

    private validateRequest(): boolean {
        let isValid = true;
        if (this.newPassword == null || this.newPassword.trim() === '') {
            this.isPwdMissing = true;
            isValid = false;
        }
        if (this.newPasswordCheck == null || this.newPasswordCheck.trim() === '') {
            this.isPwdCheckMissing = true;
            isValid = false;
        }
        if (isValid && this.newPassword !== this.newPasswordCheck) {
            this.isPwdMissing = false;
            this.isPwdCheckMissing = false;
            this.isCheckFail = true;
            isValid = false;
        }
        return isValid;
    }

}
